import React from "react";
import WarningTriangleIcon from "components/icons/24/notifications/warning-triangle.svg";

const ErrorMessage = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex flex-col items-center space-y-2 p-6 pb-8">
      <WarningTriangleIcon className="w-10 text-red-500" />
      <div className="text-center text-sm font-light">{children}</div>
    </div>
  );
};

export default ErrorMessage;
